export const safeTop = 'env(safe-area-inset-top)';
export const safeLeft = 'env(safe-area-inset-left)';
export const safeRight = 'env(safe-area-inset-right)';
export const safeBottom = 'env(safe-area-inset-bottom)';
